import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

import Login from '../auth/Login.vue';
import Register from '../auth/Register.vue';
import VerifyAccount from '../auth/VerifyAccount.vue';
import RecoverPassword from '../auth/RecoverPassword.vue';
import NewPassword from '../auth/NewPassword.vue';

import Dashboard from '../pages/Dashboard.vue';
import IssuedCfdis from "../pages/IssuedCfdis.vue"
import ReceivedCfdis from "../pages/ReceivedCfdis.vue"
import CfdisPorPagar from "../pages/CfdisPorPagar.vue"
import CfdisPorCobrar from "../pages/CfdisPorCobrar.vue"
import PaymentReconciliation from "../pages/PaymentReconciliation.vue"
import DiotWorkpaper from "../pages/DiotWorkpaper.vue"
import DownloadCenter from "../pages/DownloadCenter.vue"
import TaxesSummary from "../pages/TaxesSummary.vue"

import Validations from "../pages/Validations.vue"
import AdminAccounts from "../pages/AdminAccounts.vue"
import Settings from "../pages/Settings.vue"
import NotFound from '../pages/error/404.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Iniciar Sesión - TusCFDIs',
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: 'Crear Cuenta - TusCFDIs',
    }
  },
  {
    path: '/verify-account',
    name: 'verifyAccount',
    component: VerifyAccount,
    meta: {
      title: 'Verificar Cuenta - TusCFDIs',
    }
  },
  {
    path: '/recover-password',
    name: 'recoverPassword',
    component: RecoverPassword,
    meta: {
      title: 'Recuperar Cuenta - TusCFDIs',
    }
  },
  {
    path: '/new-password',
    name: 'newPassword',
    component: NewPassword,
    meta: {
      title: 'Recuperar Cuenta - TusCFDIs',
    }
  },
  {
    path: '/',
    component: Body,
    children: [
      {
        path: '', 
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'Bienvenido - TusCFDIs.com',
        }
      },
      {
        path: 'emitidos',
        name: 'issuedCfdis',
        component: IssuedCfdis,
        meta: {
          title: 'CFDIs Enviados - TusCFDIs.com',
        }
      },
      {
        path: 'recibidos',
        name: 'receivedCfdis',
        component: ReceivedCfdis,
        meta: {
          title: 'CFDIs Recibidos - TusCFDIs.com',
        }
      },
      {
        path: 'cfdis-por-pagar',
        name: 'cfdisPorPagar',
        component: CfdisPorPagar,
        meta: {
          title: 'CFDIs por Pagar - TusCFDIs.com',
        }
      },
      {
        path: 'cfdis-por-cobrar',
        name: 'cfdisPorCobrar',
        component: CfdisPorCobrar,
        meta: {
          title: 'CFDIs por Cobrar - TusCFDIs.com',
        }
      },
      {
        path: 'conciliacion-pagos/emitidos',
        name: 'paymentReconciliationIssued',
        component: PaymentReconciliation,
        meta: {
          title: 'Conciliación de Pagos Emitidos - TusCFDIs.com',
          paymentReconciliationNature: 'issued',
        }
      },
      {
        path: 'conciliacion-pagos/recibidos',
        name: 'paymentReconciliationReceived',
        component: PaymentReconciliation,
        meta: {
          title: 'Conciliación de Pagos Recibidos - TusCFDIs.com',
          paymentReconciliationNature: 'received',
        }
      },
      {
        path: 'papel-trabajo-diot',
        name: 'diotWorkpaper',
        component: DiotWorkpaper,
        meta: {
          title: 'Papel de Trabajo DIOT - TusCFDIs.com',
        }
      },
      {
        path: 'centro-descargas',
        name: 'downloadCenter',
        component: DownloadCenter,
        meta: {
          title: 'Centro de Descargas - TusCFDIs.com',
        }
      },
      {
        path: 'validaciones',
        name: 'validations',
        component: Validations,
        meta: {
          title: 'Validaciones - TusCFDIs.com',
        }
      },
      {
            path: 'impuestos',
            name: 'taxesSummary',
            component: TaxesSummary,
            meta: {
              title: 'Impuestos - TusCFDIs.com',
            }
          },
      {
        path: 'administracion',
        name: 'adminAccounts',
        component: AdminAccounts,
        meta: {
          title: 'Administración - TusCFDIs.com',
          requiresAdmin: true,
        }
      },
      {
        path: 'configuracion',
        name: 'settings',
        component: Settings,
        meta: {
          title: 'Configuración - TusCFDIs.com',
        }
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFound,
    meta: {
      title: 'Página no encontrada - TusCFDIs',
    }
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  const host = String(window.location.hostname || '').trim().toLowerCase();
  const appEnv = String(process.env.VUE_APP_ENV || '').trim().toLowerCase();
  const isDemoEnvironment = host === 'demo.tuscfdis.com' || appEnv === 'demo';

  if (isDemoEnvironment && ['register', 'recoverPassword', 'newPassword'].includes(String(to.name || ''))) {
    return next('/login');
  }

  const publicPaths = ['/login', '/register', '/verify-account', '/recover-password', '/new-password', '/changelog'];
  const token = localStorage.getItem('access_token');

  if (to.name === 'notFound' || publicPaths.includes(to.path) || token) {
    if (to.meta?.requiresAdmin) {
      const rawUser = localStorage.getItem('user');
      let isAdmin = false;

      if (rawUser && rawUser !== 'undefined') {
        try {
          const user = JSON.parse(rawUser) || {};
          isAdmin = Boolean(user.is_admin);
        } catch (error) {
          isAdmin = false;
        }
      }

      if (!isAdmin) {
        return next('/');
      }
    }

    return next();
  }
  next('/login');
});
export default router